import React from "react";
import Card from "../../common/Cards";

const Products = ({ data }) => {
  // Access products_section from the data object
  const { products_section } = data || {};

  // Safely destructure products array with default empty array
  const { description = "", products = [] } = products_section || {};

  return (
    <section className="py-16 bg-white sm:py-24">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="text-left">
          <h2 className="text-3xl font-semibold tracking-tight text-orange-500 sm:text-4xl">
            Products
          </h2>
          {description && (
            <p className="max-w-2xl mt-4 text-lg text-gray-600">
              {description}
            </p>
          )}
        </div>

        {products.length > 0 ? (
          <div className="grid grid-cols-1 gap-8 mt-16 sm:grid-cols-2 lg:grid-cols-3">
            {products.map((product, index) => (
              <Card
                key={`${product.title}-${index}`}
                image={product.image}
                title={product.title}
                description={product.description}
                className="transition-transform duration-300 transform hover:-translate-y-2"
              />
            ))}
          </div>
        ) : (
          <p className="mt-8 text-gray-500">No products available</p>
        )}
      </div>
    </section>
  );
};

export default Products;
